//@ts-check
import { useApp as portalApp } from '../../context/usePortal'
import { useApp as contextApp } from '../../context/app-context'
import { useEffect, useState } from 'react'
import type { UserI } from '../../types/user'
import toast from 'react-hot-toast'
import { Button } from '../ui/button'

export const UserProfile = () => {
  const { saveUser } = portalApp()
  const { userInfo } = contextApp()
  const [dataChanged, setDataChanged] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [userData, setUserData] = useState<Partial<UserI> | null | undefined>(
    userInfo,
  )

  useEffect(() => {
    setUserData(userInfo)
  }, [])

  const formatDate = (dateStr?: string) => {
    if (!dateStr) return ''
    const date = new Date(dateStr)
    if (isNaN(date.getTime())) return ''
    return date.toISOString().split('T')[0]
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDataChanged(true)
    const { name, value } = e.target
    setUserData((prevData) => ({ ...prevData, [name]: value }))
  }

  const handleSubmit = async () => {
    if (!userData) return

    setIsLoading(true)
    const response = await saveUser({
      user_name: userData.user_name ?? '',
      user_email: userData.user_email ?? '',
      user_birthday: userData.user_birthday ?? '',
      text_message: userInfo?.text_message ?? false,
      marketing_and_offers: userInfo?.marketing_and_offers ?? false,
      newsletter: userInfo?.newsletter ?? false,
    })

    setIsLoading(false)

    if (response?.isOk()) {
      setDataChanged(false)
      toast.success('Profile updated successfully.')
    } else toast.error('Some error occured')
  }

  return (
    <div className="px-4 py-6 sm:p-6 lg:pb-8">
      <div>
        <h2 className="text-lg font-medium leading-6 text-gray-900">Profile</h2>
        <p className="mt-1 text-sm text-gray-500">
          Some of this information will be displayed on Aye Face App when you
          use it, so be careful what you share.
        </p>
      </div>

      <div className="mt-6 flex flex-col lg:flex-row">
        <div className="flex-grow space-y-6">
          <div className="col-span-12 sm:col-span-6">
            <label
              htmlFor="name"
              className="block text-sm font-medium text-gray-700">
              Your name
            </label>
            <input
              type="text"
              name="user_name"
              id="name"
              value={userData?.user_name ?? userInfo?.user_name}
              onChange={handleInputChange}
              placeholder={userInfo?.user_name ?? ''}
              autoComplete="given-name"
              className="mt-1 block w-64 rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-sky-500 focus:outline-none focus:ring-sky-500 sm:text-sm"
            />
          </div>
        </div>
      </div>

      <div className="mt-2 grid grid-cols-12 gap-6">
        <div className="col-span-12 w-64 sm:col-span-6">
          <label
            htmlFor="email"
            className="block text-sm font-medium text-gray-700">
            Email
          </label>
          <input
            type="email"
            name="user_email"
            id="email"
            value={userData?.user_email ?? userInfo?.user_email}
            onChange={handleInputChange}
            placeholder={userInfo?.user_email ?? 'Please add your email'}
            autoComplete="email"
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-sky-500 focus:outline-none focus:ring-sky-500 sm:text-sm"
          />
        </div>
      </div>

      <div className="mt-2 grid grid-cols-12 gap-6">
        <div className="col-span-12 w-64 sm:col-span-6">
          <label
            htmlFor="user_birthday"
            className="block text-sm font-medium text-gray-700">
            Birthday
          </label>
          <input
            type="date"
            name="user_birthday"
            id="user_birthday"
            value={
              userData?.user_birthday
                ? formatDate(userData?.user_birthday)
                : formatDate(userInfo?.user_birthday)
            }
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-sky-500 focus:outline-none focus:ring-sky-500 sm:text-sm"
          />
        </div>
      </div>

      <div className="flex w-full justify-end mt-6">
        <Button
          type="button"
          onClick={handleSubmit}
          // className={`ml-5 inline-flex justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 ${
          //   dataChanged
          //     ? 'bg-green-700 hover:bg-green-800 focus:ring-green-500'
          //     : 'cursor-not-allowed bg-gray-400'
          // }`}
          className="min-w-24 disabled:bg-gray-700"
          disabled={!dataChanged || isLoading}>
          {isLoading ? 'Saving...' : 'Save'}
        </Button>
      </div>
    </div>
  )
}
